export const MANAGERS = [
  { id: 'vihanga',  name: 'Vihanga',  color: '#4F6EF7' },
  { id: 'adithya',  name: 'Adithya',  color: '#E05C3A' },
  { id: 'beenali',  name: 'Beenali',  color: '#2BAC76' },
  { id: 'tarini',   name: 'Tarini',   color: '#9B59B6' },
  { id: 'malindya', name: 'Malindya', color: '#F39C12' },
  { id: 'induru',   name: 'Induru',   color: '#1ABC9C' },
  { id: 'celine',   name: 'Celine',   color: '#E91E8C' },
  { id: 'ravindya', name: 'Ravindya', color: '#3498DB' },
];

export const BRANDS_INITIAL = [
  // Vihanga
  { id: 'promptxp',   name: 'PromptXP',          managerId: 'vihanga',  targetPosts: 8,  targetVideos: 0 },
  { id: 'icon',       name: 'Icon',               managerId: 'vihanga',  targetPosts: 4,  targetVideos: 0 },
  { id: 'brisca',     name: 'Brisca',             managerId: 'vihanga',  targetPosts: 6,  targetVideos: 2 },
  // Adithya
  { id: 'jksb',       name: 'JKSB',               managerId: 'adithya',  targetPosts: 12, targetVideos: 2 },
  { id: 'ambeonsec',  name: 'Ambeon Sec',          managerId: 'adithya',  targetPosts: 8,  targetVideos: 2 },
  { id: 'eni',        name: 'ENI Lubricant',       managerId: 'adithya',  targetPosts: 12, targetVideos: 2 },
  { id: 'bartleet',   name: 'Bartleet',            managerId: 'adithya',  targetPosts: 8,  targetVideos: 2 },
  { id: 'softlogic',  name: 'Softlogic Invest',    managerId: 'adithya',  targetPosts: 8,  targetVideos: 2 },
  // Malindya
  { id: 'namal',      name: 'Namal Funds',         managerId: 'malindya', targetPosts: 12, targetVideos: 4 },
  { id: 'jbconnect',  name: 'JB Connect',          managerId: 'malindya', targetPosts: 8,  targetVideos: 2 },
  { id: 'utasl',      name: 'UTASL',               managerId: 'malindya', targetPosts: 10, targetVideos: 0 },
  { id: 'ceybank',    name: 'CeyBank',             managerId: 'malindya', targetPosts: 8,  targetVideos: 2 },
  // Induru
  { id: 'goodearth',  name: 'Good Earth',          managerId: 'induru',   targetPosts: 8,  targetVideos: 0 },
  { id: 'aaa',        name: 'AAA',                 managerId: 'induru',   targetPosts: 12, targetVideos: 0 },
  { id: 'automark',   name: 'Automark',            managerId: 'induru',   targetPosts: 8,  targetVideos: 2 },
  // Celine
  { id: 'sosoft',     name: 'So Soft',             managerId: 'celine',   targetPosts: 8,  targetVideos: 4 },
  { id: 'tukki',      name: 'Tukki',               managerId: 'celine',   targetPosts: 12, targetVideos: 4 },
  { id: 'idealpremier',name:'Ideal Premier',        managerId: 'celine',   targetPosts: 6,  targetVideos: 2 },
  // Ravindya
  { id: 'sampath',    name: 'Sampath Securities',  managerId: 'ravindya', targetPosts: 8,  targetVideos: 2 },
  { id: 'synergy',    name: 'Synergy',             managerId: 'ravindya', targetPosts: 6,  targetVideos: 0 },
  // Tarini
  { id: 'crescat',    name: 'Crescat',             managerId: 'tarini',   targetPosts: 9,  targetVideos: 3 },
  { id: 'kzone',      name: 'K Zone',              managerId: 'tarini',   targetPosts: 8,  targetVideos: 2 },
  { id: 'alphafire',  name: 'Alpha Fire',          managerId: 'tarini',   targetPosts: 4,  targetVideos: 0 },
  { id: 'asfreight',  name: 'AS Freight',          managerId: 'tarini',   targetPosts: 5,  targetVideos: 0 },
  // Beenali
  { id: 'mydmv',      name: 'MYD MV',              managerId: 'beenali',  targetPosts: 10, targetVideos: 0 },
  { id: 'mydsl',      name: 'MYD SL',              managerId: 'beenali',  targetPosts: 8,  targetVideos: 0 },
  { id: 'segafredo',  name: 'Segafredo',           managerId: 'beenali',  targetPosts: 12, targetVideos: 2 },
  { id: 'subwaysl',   name: 'Subway SL',           managerId: 'beenali',  targetPosts: 10, targetVideos: 0 },
];

export const SPECIAL_DAYS_INITIAL = [
  { id: 'fathersday2026', name: "Father's Day", date: '2026-06-15', month: '2026-06' },
  { id: 'poson2026',      name: 'Poson Poya',   date: '2026-06-11', month: '2026-06' },
];

export const PLATFORMS = ['Facebook', 'Instagram', 'TikTok', 'LinkedIn'];

export const FOLLOWERS_INITIAL = {
  '2026-05': {
    Facebook:  323265,
    Instagram:  33898,
    TikTok:     52888,
    LinkedIn:   19064,
  },
  '2026-06': {
    Facebook:  329788,
    Instagram:  34605,
    TikTok:     52005,
    LinkedIn:   20151,
  },
};

// Brand-level follower breakdown May/Jun
export const BRAND_FOLLOWERS_INITIAL = {
  '2026-05': {
    Facebook: {
      'Subway SL': 86000, 'Tukki': 60000, 'Crescat': 35000, 'ENI Lubricant': 34000,
      'K Zone': 33000, 'PromptXP': 13000, 'JKSB': 10000, 'Softlogic Invest': 7800,
      'So Soft': 3300, 'Segafredo': 50, 'CeyBank': 1500, 'Namal Funds': 1100,
      'Ambeon Sec': 284, 'JB Connect': 254, 'UTASL': 4900, 'Sampath Securities': 4500,
      'AAA': 1900, 'Alpha Fire': 1700, 'AS Freight': 3000, 'Good Earth': 521,
    },
    Instagram: {
      'Tukki': 8516, 'Crescat': 4662, 'So Soft': 4038, 'Softlogic Invest': 2531,
      'JKSB': 1425, 'UTASL': 1275, 'Subway SL': 1265, 'Segafredo': 1012,
      'AAA': 794, 'PromptXP': 687, 'K Zone': 620, 'ENI Lubricant': 507,
      'Namal Funds': 375, 'CeyBank': 222, 'AS Freight': 182, 'Alpha Fire': 133,
      'Sampath Securities': 118, 'Ambeon Sec': 86, 'JB Connect': 78,
    },
    TikTok: {
      'Tukki': 41400, 'So Soft': 2619, 'Crescat': 2168, 'AS Freight': 1641,
      'Sampath Securities': 1248, 'PromptXP': 1061, 'ENI Lubricant': 1013,
      'CeyBank': 308, 'UTASL': 255, 'JKSB': 36,
    },
    LinkedIn: {
      'JKSB': 7222, 'AS Freight': 2000, 'Ambeon Sec': 2000, 'Namal Funds': 1100,
      'Softlogic Invest': 1000, 'Sampath Securities': 1000, 'UTASL': 705,
      'AAA': 370, 'Alpha Fire': 262, 'PromptXP': 212, 'Good Earth': 158,
      'CeyBank': 139,
    },
  },
  '2026-06': {
    Facebook: {
      'Subway SL': 86290, 'Tukki': 60153, 'Crescat': 35508, 'ENI Lubricant': 34674,
      'K Zone': 33395, 'PromptXP': 14284, 'JKSB': 10995, 'Softlogic Invest': 7924,
      'So Soft': 3294, 'Segafredo': 126, 'CeyBank': 1392, 'Namal Funds': 1108,
      'Ambeon Sec': 297, 'JB Connect': 290, 'UTASL': 5228, 'Sampath Securities': 4878,
      'AAA': 1995, 'Alpha Fire': 1771, 'AS Freight': 3123, 'Good Earth': 535,
    },
    Instagram: {
      'Tukki': 8437, 'Crescat': 4743, 'So Soft': 4009, 'Softlogic Invest': 2535,
      'JKSB': 1479, 'UTASL': 1344, 'Subway SL': 1488, 'Segafredo': 1016,
      'AAA': 791, 'PromptXP': 722, 'K Zone': 623, 'ENI Lubricant': 510,
      'Namal Funds': 388, 'CeyBank': 261, 'AS Freight': 185, 'Alpha Fire': 136,
      'Sampath Securities': 125, 'Ambeon Sec': 89, 'JB Connect': 116,
    },
    TikTok: {
      'Tukki': 41200, 'So Soft': 2680, 'Crescat': 1240, 'AS Freight': 1644,
      'Sampath Securities': 1247, 'PromptXP': 1080, 'ENI Lubricant': 1062,
      'CeyBank': 312, 'UTASL': 259, 'JKSB': 37,
    },
    LinkedIn: {
      'JKSB': 7294, 'AS Freight': 1718, 'Ambeon Sec': 1889, 'Namal Funds': 1129,
      'Softlogic Invest': 1451, 'Sampath Securities': 1283, 'UTASL': 714,
      'AAA': 371, 'Alpha Fire': 267, 'PromptXP': 213, 'Good Earth': 162,
      'CeyBank': 239,
    },
  },
};
